// const reactDatePickerStringValueToUnix = (val) => {
//   return Date.parse(moment.from(digitsFaToEn(val), "fa", "YYYY/MM/DD").format("YYYY/MM/DD")) / 1000;
// };
const unixToPersianDate = (unix) => {
  let options = { year: "numeric", month: "numeric", day: "numeric" };
  let date = new Date(parseInt(unix) * 1000).toLocaleDateString(
    "fa-IR",
    options
  );
  date.replace(/([۰-۹])/g, (token) =>
    String.fromCharCode(token.charCodeAt(0) - 1728)
  );
  return date;
};
const maskNumber = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
const translateToReactSelect = (arrayValue, reverse) => {
  let after = [];
  if (reverse) {
    // react select to api
    for (let index = 0; index < arrayValue.length; index++) {
      let obj = {};
      obj.title = arrayValue[index].label;
      obj.id = arrayValue[index].value;
      after.push(obj);
    }
  } else {
    // api to react select
    for (let index = 0; index < arrayValue.length; index++) {
      let obj = {};
      obj.label = arrayValue[index].title;
      obj.value = arrayValue[index].id;
      after.push(obj);
    }
  }

  return after;
};

const translateToProductReactSelect = (arrayValue, reverse) => {
  let after = [];
  if (reverse) {
    // react select to api
    for (let index = 0; index < arrayValue.length; index++) {
      let obj = {};
      obj.title = arrayValue[index].label;
      obj.id = arrayValue[index].value;
      after.push(obj);
    }
  } else {
    // api to react select
    for (let index = 0; index < arrayValue.length; index++) {
      let obj = {};
      obj.label = arrayValue[index].title;
      obj.value = arrayValue[index].products__id;
      obj.option = JSON.parse(arrayValue[index].available_order_option_ids);
      obj.default_price = arrayValue[index].default_price;
      obj.image = arrayValue[index].path;
      obj.total_inventory_count = arrayValue[index].total_inventory_count;
      obj.default_weight_from = arrayValue[index].default_weight_from;
      obj.default_weight_to = arrayValue[index].default_weight_to;
      obj.main_cover_file_id = arrayValue[index].main_cover_file_id;

      after.push(obj);
    }
  }

  return after;
};

const translateToProductReactSelect1 = (arrayValue, reverse) => {
  let after = [];
  if (reverse) {
    // react select to api
    for (let index = 0; index < arrayValue.length; index++) {
      let obj = {};
      obj.title = arrayValue[index].label;
      obj.id = arrayValue[index].value;
      after.push(obj);
    }
  } else {
    // api to react select
    for (let index = 0; index < arrayValue.length; index++) {
      let obj = {};
      obj.label = arrayValue[index].info.title;
      obj.value = arrayValue[index].info.avb_product_for_order__id;
      obj.option = JSON.parse(
        arrayValue[index].info.available_order_option_ids
      );
      obj.price = arrayValue[index].info.price;
      obj.discount = arrayValue[index].info.discount;
      // obj.image = arrayValue[index].info.product_cover_img;
      obj.image = arrayValue[index].info.supplier_cover_img;
      obj.image2 = arrayValue[index].info.product_cover_img;
      // obj.total_inventory = arrayValue[index].total_inventory;
      obj.total_inventory_count = arrayValue[index].info.total_inventory_count;
      obj.complate_inventory_count =
        arrayValue[index].info.complate_inventory_count;
      obj.frozen_inventory_count =
        arrayValue[index].info.frozen_inventory_count;
      // obj.total_inventory = 5;
      // obj.default_weight_from = arrayValue[index].default_weight_from;
      // obj.default_weight_to = arrayValue[index].default_weight_to;

      after.push(obj);
    }
  }

  return after;
};

const phoneNumberValidation = (phoneNumber) => {
  return /^09\d{9}$/.test(phoneNumber);
};
const objToFormData = (object) => {
  const formData = new FormData();
  Object.keys(object).forEach((key) => formData.append(key, object[key]));
  return formData;
};

export {
  unixToPersianDate,
  maskNumber,
  translateToReactSelect,
  translateToProductReactSelect,
  translateToProductReactSelect1,
  phoneNumberValidation,
  objToFormData,
};
